var _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrnaments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 106,
    viewBox: "0 0 234 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34.375,
    y1: 0.00280846,
    x2: 34.126,
    y2: 33.2529,
    stroke: "#E5E5E5",
    strokeWidth: 0.750001,
    strokeDasharray: "2.25 2.25"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 194.375,
    y1: -1.63918e-8,
    x2: 194.375,
    y2: 24,
    stroke: "#E5E5E5",
    strokeWidth: 0.750001,
    strokeDasharray: "2.25 2.25"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 152.375,
    y1: -1.63918e-8,
    x2: 152.375,
    y2: 9,
    stroke: "#E5E5E5",
    strokeWidth: 0.750001,
    strokeDasharray: "2.25 2.25"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 104.375,
    y1: -1.63918e-8,
    x2: 104.375,
    y2: 24,
    stroke: "#E5E5E5",
    strokeWidth: 0.750001,
    strokeDasharray: "2.25 2.25"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 68.375,
    y1: -1.63918e-8,
    x2: 68.375,
    y2: 6,
    stroke: "#E5E5E5",
    strokeWidth: 0.750001,
    strokeDasharray: "2.25 2.25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.259 32.5C95.2042 32.5 87.7914 39.5319 87.1838 48.4329C78.2823 49.04 71.2499 56.4531 71.2499 65.5086C71.2499 74.5641 78.2823 81.9772 87.1838 82.5843C87.7909 91.4857 95.2039 98.5182 104.259 98.5182C113.315 98.5182 120.728 91.4857 121.335 82.5841C130.236 81.9761 137.267 74.5635 137.267 65.5086C137.267 56.4537 130.236 49.0411 121.335 48.4331C120.728 39.532 113.315 32.5 104.259 32.5Z",
    fill: "#01BFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1277 48.3298C80.7069 49.002 80.7069 49.8628 81.1277 50.5349C82.9345 53.4216 84 56.9694 84 60.7707C84 61.0993 83.9921 61.4259 83.9765 61.7501C83.9921 62.0743 84 62.4009 84 62.7295C84 66.5308 82.9345 70.0786 81.1277 72.9653C80.7069 73.6374 80.7069 74.4982 81.1277 75.1704C82.9345 78.057 84 81.6048 84 85.4062C84 95.1219 77.1172 103 68.625 103C60.1328 103 53.25 95.1219 53.25 85.4062C53.25 81.6048 54.3154 78.057 56.1223 75.1704C56.543 74.4982 56.543 73.6374 56.1223 72.9653C54.3154 70.0786 53.25 66.5308 53.25 62.7295C53.25 62.4009 53.2579 62.0743 53.2734 61.7501C53.2579 61.4259 53.25 61.0993 53.25 60.7707C53.25 56.9694 54.3154 53.4216 56.1223 50.5349C56.543 49.8628 56.543 49.002 56.1223 48.3298C54.3154 45.4432 53.25 41.8954 53.25 38.0941C53.25 28.3783 60.1328 20.5001 68.625 20.5001C77.1172 20.5001 84 28.3783 84 38.0941C84 41.8954 82.9345 45.4432 81.1277 48.3298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9187 50.0933C80.9698 50.2461 81.0392 50.3941 81.1267 50.534C82.9336 53.4207 83.999 56.9685 83.999 60.7698C83.999 61.0985 83.9912 61.4252 83.9756 61.7495C83.9912 62.0737 83.999 62.4004 83.999 62.7291C83.999 66.5304 82.9336 70.0782 81.1267 72.9648C80.706 73.637 80.706 74.4978 81.1267 75.17C82.378 77.1689 83.2737 79.485 83.7062 81.9827C76.5177 79.9537 71.2495 73.3464 71.2495 65.5086C71.2495 58.7248 75.1962 52.8627 80.9187 50.0933Z",
    fill: "#256B8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.868 33.9404C193.138 31.8956 196.113 31.8956 197.383 33.9404L203.031 43.0337C203.77 44.224 205.189 44.8057 206.551 44.4764L217.201 41.9013C219.585 41.3249 221.722 43.4987 221.106 45.8726L218.528 55.7972C218.161 57.2096 218.782 58.6931 220.045 59.4235L229.14 64.6822C231.302 65.9321 231.302 69.0528 229.14 70.3027L220.045 75.5614C218.782 76.2918 218.161 77.7753 218.528 79.1876L221.106 89.1123C221.722 91.4861 219.585 93.66 217.201 93.0836L206.551 90.5085C205.189 90.1792 203.77 90.7609 203.031 91.9511L197.383 101.045C196.113 103.089 193.138 103.089 191.868 101.045L186.221 91.9511C185.481 90.7609 184.062 90.1792 182.7 90.5085L172.05 93.0836C169.666 93.66 167.529 91.4861 168.145 89.1123L170.723 79.1876C171.09 77.7753 170.469 76.2918 169.206 75.5614L160.111 70.3027C157.949 69.0528 157.949 65.9321 160.111 64.6822L169.206 59.4235C170.469 58.6931 171.09 57.2096 170.723 55.7972L168.145 45.8726C167.529 43.4987 169.666 41.3249 172.05 41.9013L182.7 44.4764C184.062 44.8057 185.481 44.224 186.221 43.0337L191.868 33.9404Z",
    fill: "#256B8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.504 29.5C147.754 25.75 147.754 16.75 147.754 16.75H157.504C157.504 16.75 157.03 25.6666 163.128 29.5C173.251 35.8629 178.785 39.625 181.503 54.2501C185.451 75.4861 153.001 103 153.001 103C153.001 103 120.754 74.5001 123.379 55.7501C126.003 37 137.254 33.25 142.504 29.5Z",
    fill: "#E7F4FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.104 43.3647C179.544 46.2144 180.66 49.7086 181.504 54.2504C183.469 64.8215 176.415 76.9483 168.834 86.4625L170.724 79.1875C171.09 77.7751 170.47 76.2916 169.207 75.5612L160.112 70.3026C157.95 69.0526 157.95 65.9319 160.112 64.682L169.207 59.4234C170.47 58.693 171.09 57.2094 170.724 55.7971L168.146 45.8724C167.529 43.4986 169.667 41.3247 172.051 41.9012L178.104 43.3647Z",
    fill: "#ABD8F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.3 78.4986C126.168 70.866 122.414 62.6484 123.38 55.7505C123.728 53.2626 124.228 51.0388 124.846 49.0441C132.018 51.0838 137.27 57.683 137.27 65.5089C137.27 70.7046 134.955 75.3596 131.3 78.4986Z",
    fill: "#037DBA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8751 75.6252C67.8751 75.6252 47.587 100 34.1251 100C20.6631 100 0 75.6252 0 75.6252C0 75.6252 20.6631 51.2501 34.1251 51.2501C47.587 51.2501 67.8751 75.6252 67.8751 75.6252Z",
    fill: "#037DBA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 43.7501H37.5001C37.5001 43.7501 37.278 48.6125 38.6251 51.2501C39.4781 52.9204 42.0001 53.8751 42.0001 53.8751H25.5001C25.5001 53.8751 27.8363 53.0419 28.8751 51.2501C30.3605 48.6879 30.0001 43.7501 30.0001 43.7501Z",
    fill: "#037DBA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7405 89.834C61.6139 83.1472 67.8745 75.6254 67.8745 75.6254C67.8745 75.6254 61.3527 67.7897 53.2508 61.0037C53.2537 61.2538 53.2611 61.5027 53.2729 61.7502C53.2574 62.0745 53.2495 62.401 53.2495 62.7296C53.2495 66.531 54.315 70.0788 56.1218 72.9654C56.5425 73.6376 56.5425 74.4984 56.1218 75.1705C54.315 78.0571 53.2495 81.6049 53.2495 85.4063C53.2495 86.9356 53.42 88.4193 53.7405 89.834Z",
    fill: "#01BFF3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.7505,
    cy: 39.2503,
    r: 5.81251,
    stroke: "#037DBA",
    strokeWidth: 0.375001
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.998,
    cy: 29.4996,
    r: 5.06251,
    stroke: "#256B8A",
    strokeWidth: 0.375001
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.625,
    cy: 14.875,
    r: 5.43751,
    stroke: "#E7F4FC",
    strokeWidth: 0.375001
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.25,
    cy: 30.2496,
    r: 5.81251,
    stroke: "#01BFF3",
    strokeWidth: 0.375001
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 12.25,
    r: 5.81251,
    stroke: "white",
    strokeWidth: 0.375001
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.2505,
    y: 14.4999,
    width: 7.50002,
    height: 9.00002,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnaments);
export default __webpack_public_path__ + "static/media/ornaments.458a1a5a.svg";
export { ForwardRef as ReactComponent };